let trend_data = [
    {
        type: '공용',
        name: '휠라 인터런',
        price: '99,000원',
        imgUrl: '/img/trend1.jpg'
    },
    {
        type: '공용',
        name: '매치 OG 1992',
        price: '89,000원',
        imgUrl: '/img/trend2.jpg'
    },
    {
        type: '공용',
        name: '휠라 멜비스 프로',
        price: '89,000원',
        imgUrl: '/img/trend3.jpg'
    },
    {
        type: '공용',
        name: '휠라 멜비스 프로',
        price: '89,000원',
        imgUrl: '/img/trend4.jpg'
    },
    {
        type: '공용',
        name: '휠라 토러스 v3',
        price: '79,000원',
        imgUrl: '/img/trend5.jpg'
    },
    {
        type: '공용',
        name: '휠라 토러스 v3',
        price: '79,000원',
        imgUrl: '/img/trend6.jpg'
    },
    {
        type: '공용 컴포트핏 라이프스타일',
        name: '뉴헤리티지 카라맨투맨',
        price: '79,000원',
        imgUrl: '/img/trend7.jpg'
    },
    {
        type: '공용 컴포트핏 라이프스타일',
        name: '뉴헤리티지 카라맨투맨',
        price: '79,000원',
        imgUrl: '/img/trend8.jpg'
    },
    {
        type: '공용 컴포트핏 라이프스타일',
        name: '뉴헤리티지 로고포인트 맨투맨',
        price: '69,000원',
        imgUrl: '/img/trend9.jpg'
    },
    {
        type: '공용 컴포트핏 라이프스타일',
        name: '뉴헤리티지 로고포인트 맨투맨',
        price: '69,000원',
        imgUrl: '/img/trend10.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '숄카라 보아 플리스',
        price: '129,000원',
        imgUrl: '/img/trend11.jpg'
    },
    {
        type: '공용 컴포트핏 라이프스타일',
        name: '서클로고 와이드핏 팬츠',
        price: '89,000원',
        imgUrl: '/img/trend12.jpg'
    },
    {
        type: '공용 컴포트핏 라이프스타일',
        name: '뉴헤리티지 우븐조거팬츠',
        price: '89,000원',
        imgUrl: '/img/trend13.jpg'
    }
]


export default trend_data;